'use client'
import BodyFullWidthContainer from '@/UI/BodyFullWidthContainer/BodyFullWidthContainer'
import { colors } from '@/Theme/LegacyTheme'
import CallbackFooter from '@/components/CallbackFooter/CallbackFooter'

export default function CallbackLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <BodyFullWidthContainer bgColor={colors.white}>
        {children}
        <CallbackFooter />
      </BodyFullWidthContainer>
    </>
  )
}
